import AnesthetistQuestionaryFormContainer from './AnesthetistQuestionaryFormContainer';

export default AnesthetistQuestionaryFormContainer;
